/**
 * The content picker's first pages, kept for a short while per account so the
 * picker opens on what it showed last (or what a hover prefetched) instead of
 * waiting on OnlyFans again. Later pages are never cached: they are only
 * asked for while scrolling.
 */

/** OnlyFans' signed thumb links stay valid far longer; the vault may change sooner. */
export const PICKER_CACHE_MS = 2 * 60 * 1000

interface Entry {
  at: number
  value: Promise<unknown>
}

const entries = new Map<string, Entry>()

/** `load()` once per key within PICKER_CACHE_MS; a failed load is forgotten at once. */
export function cachedPage<T>(key: string, load: () => Promise<T>, now = Date.now()): Promise<T> {
  const hit = entries.get(key)
  if (hit && now - hit.at < PICKER_CACHE_MS) return hit.value as Promise<T>
  const value = load()
  const entry = { at: now, value }
  entries.set(key, entry)
  value.catch(() => entries.get(key) === entry && entries.delete(key))
  return value
}

/** Drop an account's cached pages (Refresh, or after the vault changed). */
export function forgetPages(accountId: string) {
  for (const key of entries.keys()) if (key.startsWith(`${accountId}|`)) entries.delete(key)
}

export const categoriesKey = (accountId: string) => `${accountId}|lists`
export const mediaKey = (accountId: string, listId: string, type: string, sort: string) => `${accountId}|media|${listId}|${type}|${sort}`
